<template>
	<div class="policy-term">
		<Layout>
			<h1
				v-if="data.Title"
				class="h1 page-title"
				data-test="PolicyTerm-title"
				v-html="data.Title"
			/>
			<div
				v-if="data.Content"
				class="page-content"
				data-test="PolicyTerm-content"
				v-html="data.Content"
			/>
		</Layout>
	</div>
</template>

<script lang="ts" src="./policy-term.ts"></script>

<style lang="scss">
	.view.policy-term {
		.page-title {
			margin-bottom: 1rem;
		}
	}
</style>
